import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetgetAllEnabledPriceList(club, type,  salesChannel) {

  var url = "/reservation/check_all_year_hours_price/" + club + "/" + type + "/" + salesChannel; 

  return FetchGetDataWithAuthNEW(url);
}

